/* eslint-disable no-underscore-dangle */
import React from 'react';

import { AdyenChangePaymentMethodForm } from './providers/Adyen';
import { useUser } from '@hooks/user/useUser';
import Loader from '@components/Loader/Loader';
import { checkUserSubsContractType } from '@helpers/checkUserSubsContractType';

import styles from './ChangePaymentMethodForm.module.scss';

export const ChangePaymentMethodForm = ({
  forRentingTitle,
  forRentingText,
  forFinanceTitle,
  forFinanceText,
  ...props
}) => {
  const { data: user, isLoading } = useUser();
  if (isLoading) {
    // @ts-ignore
    return <Loader />;
  }

  const { hasUserFinanceSubs, hasUserRentalSubs } = checkUserSubsContractType(user);

  return (
    <div className={styles.container}>
      {hasUserRentalSubs && (
        <div>
          <div className={styles.title}>{forRentingTitle}</div>
          <div className={styles.text}>{forRentingText}</div>
          <AdyenChangePaymentMethodForm {...props} />
        </div>
      )}
      {hasUserFinanceSubs && (
        <div>
          <div className={styles.title}>{forFinanceTitle}</div>
          <div className={styles.text}>{forFinanceText}</div>
        </div>
      )}
    </div>
  );
};
